import React from "react";
import { ruleCarrying, validPostiConnect } from "./ShipmentRules";
import { returnToOffice, toFixedNumber } from "./Utils";
import { FaStore } from "react-icons/fa";
import DPDSVG from "../../assets/images/shipment/DPD.svg";
import OMNIVASVG from "../../assets/images/shipment/OMNIVA.svg";
import LPEXPRESSSVG from "../../assets/images/shipment/LPEXPRESS.svg";
import venipakSVG from "../../assets/images/shipment/venipak.svg";
import postiSVG from "../../assets/images/shipment/posti.svg";
import itellaSVG from "../../assets/images/shipment/itella.svg";
import matkahuoltoSVG from "../../assets/images/shipment/matkahuolto.svg";
import zipasgoSVG from "../../assets/images/shipment/zipasgo.svg";
import siuntuPilotaiSVG from "../../assets/images/shipment/siuntu_pilotai.svg";
import { last_arr } from "./array";

// UKD
const uznesimoOptions = [
  "užnešimas",
  "uznešanas",
  "toodete kandeteenus",
  "kuni",
];

export const renderTextInBlock = (e) => {
  // cia logo url
  switch (e.value) {
    case "at_the_store":
      return (
        <span>
          <FaStore className="mr-1" />
          in the office.
        </span>
      );
    case "omniva":
      return <img src={OMNIVASVG} />;
    case "dpd":
      return <img src={DPDSVG} />;
    case "venipak":
      return <img src={venipakSVG} style={{ width: 65 }} />;
    case "lp_express":
      return <img src={LPEXPRESSSVG} style={{ width: 65 }} />;
    case "posti":
      return <img src={postiSVG} style={{ width: 65, height: 20 }} />;
    case "itella":
      return <img src={itellaSVG} style={{ width: 65, height: 25 }} />;
    case "matkahuolto":
      return <img src={matkahuoltoSVG} style={{ width: 65, height: 25 }} />;
    case "zipasgo":
      return <img src={zipasgoSVG} style={{ width: 65, height: 25 }} />;
    case "siuntu_pilotai":
      return <img src={siuntuPilotaiSVG} style={{ width: 65 }} />;
    case "own_transport":
      return (
        <span>
          <FaBoxOpen className="mr-1" />
          Technorama
        </span>
      );
    default:
      return e.label;
  }
};

export const delivery_by_order_type = {
  dpd: [
    {
      value: "dpd_b2c",
      label: "B2C shipment (for private person)",
    },
    {
      value: "dpd_postMachine",
      label: "Delivery to the post machine",
    },
  ],
  omniva: [
    {
      value: "omniva_home",
      label: "Home delivery",
    },
    {
      value: "omniva_postMachine",
      label: "Delivery to the post machine",
    },
  ],
  lp_express: [
    {
      value: "lp_express_home",
      label: "Home delivery",
    },
    {
      value: "lp_express_postMachine",
      label: "Delivery to the post machine",
    },
  ],
  venipak: [
    {
      value: "venipak_home",
      label: "Home delivery",
    },
    {
      value: "venipak_postMachine",
      label: "Delivery to the post machine",
    },
  ],
  posti: [
    {
      value: "posti_home",
      label: "Home delivery",
    },
    {
      value: "posti_postMachine",
      label: "Delivery to the post machine",
    },
  ],
  itella: [
    {
      value: "itella_home",
      label: "Home delivery",
    },
    {
      value: "itella_postMachine",
      label: "Delivery to the post machine",
    },
  ],
  matkahuolto: [
    {
      value: "matkahuolto_home",
      label: "Home delivery",
    },
    {
      value: "matkahuolto_postMachine",
      label: "Delivery to the post machine",
    },
  ],
  zipasgo: [
    {
      value: "zipasgo_home",
      label: "Home delivery",
    },
    {
      value: "zipasgo_postMachine",
      label: "Delivery to the post machine",
    },
  ],
  at_the_store: [
    {
      value: "lp_express",
      label: "LP express",
    },
    {
      value: "dpd",
      label: "DPD",
    },
  ],
  siuntu_pilotai: [
    {
      value: "siuntu_pilotai_home",
      label: "Home delivery",
    },
  ],
};

export const initialShipmentValues = (
  {
    carrier,
    shipping_address,
    billing_address,
    remark,
    cod,
    leasing_cod,
    payment_module,
    order_rows,
  },
  pickup_addresses = [],
) => {
  const { delivery, order_type } = orderTypeMount(
    carrier,
    shipping_address.parcel_terminal_id,
  );

  const address =
    order_type === "at_the_store"
      ? {
          ...returnToOffice({ billing_address, carrier }, pickup_addresses),
          comment: remark,
        }
      : {
          ...shipping_address,
          comment: remark,
          postal_code:
            order_type == "dpd" || order_type == "venipak"
              ? shipping_address.postal_code.replace(/lv-/gi, "")
              : shipping_address.postal_code,
        };

  const general = {
    cod: setCod({
      cod,
      leasing_cod,
      shipment_type: order_type,
      payment_module,
    }),
    carrying: ruleCarrying({
      order_type,
      delivery,
    })
      ? have_attr_carrying(order_rows)
      : false,
  };

  return {
    shipment_type: order_type,
    delivery,
    address,
    general,
  };
};

export const handleChangeOrdertypeGlobal = (
  value,
  old_value,
  shipping_address,
  billing_address,
  props_cod,
  default_carrier,
  pickup_addresses = [],
) => {
  const removeLVPrefix = (postalCode) => postalCode.replace(/lv-/gi, "");
  const determineDeliveryType = (value, old_value, shipmentParcelTerminal) => {
    switch (value) {
      case "omniva":
        return shipmentParcelTerminal ? "omniva_postMachine" : "omniva_home";
      case "dpd":
        return shipmentParcelTerminal ? "dpd_postMachine" : "dpd_b2c";
      case "lp_express":
        return shipmentParcelTerminal
          ? "lp_express_postMachine"
          : "lp_express_home";
      case "venipak":
        return shipmentParcelTerminal ? "venipak_postMachine" : "venipak_home";
      case "posti":
        return shipmentParcelTerminal ? "posti_postMachine" : "posti_home";
      case "itella":
        return shipmentParcelTerminal ? "itella_postMachine" : "itella_home";
      case "zipasgo":
        return shipmentParcelTerminal ? "zipasgo_postMachine" : "zipasgo_home";
      case "matkahuolto":
        return shipmentParcelTerminal
          ? "matkahuolto_postMachine"
          : "matkahuolto_home";
      case "at_the_store":
        return {
          cod: false,
          delivery: old_value === "lp_express" ? "lp_express" : "dpd",
          pack: 1,
          weight: 1,
          shipping_address_edit: returnToOffice(
            { billing_address, carrier: default_carrier },
            pickup_addresses,
          ),
        };
      default:
        return false;
    }
  };

  // Main logic
  const objectBasic = {
    cod: props_cod || false,
    delivery_after_18: false,
    sendingDocuments: false,
    deliveryTime: false,
    deliveryOnSaturday: false,
    delivery_same_day: false,
    terminalSelected: undefined,
    swap: false,
    deliveryTimeHours: ["", ""],
    order_type: value,
    who: "",
    shipping_address_edit: shipping_address,
    weight: 1,
    pack: 1,
  };

  if (old_value === "omniva" && value === "dpd") {
    objectBasic.delivery = "dpd_b2c";
    objectBasic.shipping_address_edit = {
      ...shipping_address,
      postal_code: removeLVPrefix(shipping_address.postal_code),
    };
  } else {
    const shipmentParcelTerminal =
      !shipping_address.company_code && shipping_address.parcel_terminal_id;
    const deliveryType = determineDeliveryType(
      value,
      old_value,
      shipmentParcelTerminal,
    );
    if (typeof deliveryType === "string") {
      objectBasic.delivery = deliveryType;
      if (value === "dpd") {
        objectBasic.shipping_address_edit = {
          ...shipping_address,
          postal_code: removeLVPrefix(shipping_address.postal_code),
        };
      }
      if (
        default_carrier &&
        !!shipmentParcelTerminal &&
        default_carrier.identifier?.includes("_pickup") &&
        objectBasic.delivery?.includes("_postMachine")
      ) {
        const deliveryReplaced = objectBasic.delivery.replace(
          "_postMachine",
          "",
        );
        const carrierIdentifierReplaced = default_carrier.identifier.replace(
          "_pickup",
          "",
        );
        if (deliveryReplaced == carrierIdentifierReplaced) {
          objectBasic.terminalSelected = shipmentParcelTerminal;
        } else if (
          ["posti", "itella"].includes(carrierIdentifierReplaced) &&
          ["posti", "itella"].includes(deliveryReplaced)
        ) {
          objectBasic.terminalSelected = shipmentParcelTerminal;
        }
      }
    } else if (typeof deliveryType === "object") {
      return {
        ...objectBasic,
        ...deliveryType,
      };
    } else {
      objectBasic.delivery = false;
    }
  }

  return objectBasic;
};

export const onChangeCheckBoxDelivery = (e) => {
  const parentName = e.target.name;
  if (this.state.delivery !== parentName) {
    let deliveryInfo = {};
    const isPostMachine = parentName.includes("_postMachine");
    if (
      "lp_express_postMachine" == parentName ||
      "omniva_postMachine" == parentName ||
      "dpd_postMachine" == parentName ||
      "venipak_postMachine" == parentName
    ) {
      deliveryInfo.pack = 1;
    }
    if (
      "lp_express_home" === parentName ||
      "lp_express_postMachine" === parentName
    ) {
      deliveryInfo.lp_express_sizes = undefined;
    }
    // Save terminalSelected when switching to non-postMachine delivery
    // Restore it when switching back to postMachine delivery
    if (!isPostMachine) {
      deliveryInfo.savedTerminalSelected = this.state.terminalSelected;
      deliveryInfo.terminalSelected = undefined;
    } else if (this.state.savedTerminalSelected) {
      deliveryInfo.terminalSelected = this.state.savedTerminalSelected;
      deliveryInfo.savedTerminalSelected = undefined;
    }
    this.setState({
      ...deliveryInfo,
      swap: false,
      delivery: e.target.name,
    });
  } else {
    this.setState({
      delivery: false,
    });
  }
};

export const onChangeCheckBoxDeliveryGlobal = (
  e,
  delivery,
  terminalSelected = undefined,
  savedTerminalSelected = undefined,
) => {
  const parentName = e.target.name;
  if (delivery !== parentName) {
    let deliveryInfo = {};
    const isPostMachine = parentName.includes("_postMachine");
    if (
      "lp_express_postMachine" == parentName ||
      "omniva_postMachine" == parentName ||
      "dpd_postMachine" == parentName ||
      "venipak_postMachine" == parentName
    ) {
      deliveryInfo.pack = 1;
    }
    if (
      "lp_express_home" === parentName ||
      "lp_express_postMachine" === parentName
    ) {
      deliveryInfo.lp_express_sizes = undefined;
    }
    // Save terminalSelected when switching to non-postMachine delivery
    // Restore it when switching back to postMachine delivery
    if (!isPostMachine) {
      deliveryInfo.savedTerminalSelected = terminalSelected;
      deliveryInfo.terminalSelected = undefined;
    } else if (savedTerminalSelected) {
      deliveryInfo.terminalSelected = savedTerminalSelected;
      deliveryInfo.savedTerminalSelected = undefined;
    }
    return {
      ...deliveryInfo,
      swap: false,
      delivery: e.target.name,
    };
  } else {
    return {
      delivery: false,
    };
  }
};

export const orderTypeMount = (carrier, parcel_terminal_id) => {
  let order_type = "";
  let delivery = false;
  const carrier_identifier = carrier?.identifier || "";
  const identifier = carrier_identifier
    .replace("_pickup", "")
    .replace("_home", "");

  if (carrier?.module_name == "omnivaltshipping" || identifier == "omniva") {
    order_type = "omniva";
  } else if (carrier?.module_name == "technocarrier" || identifier == "dpd") {
    order_type = "dpd";
  } else if (
    carrier?.module_name == "lpexpress" ||
    identifier == "lp_express"
  ) {
    order_type = "lp_express";
  } else if (
    carrier?.module_name == "mijoravenipak" ||
    identifier == "venipak"
  ) {
    order_type = "venipak";
  } else if (
    carrier?.module_name == "upickupatstore" ||
    identifier == "store"
  ) {
    order_type = "at_the_store";
    delivery = "dpd";
  } else if (
    carrier?.module_name == "itellashipping" ||
    identifier == "posti"
  ) {
    order_type = "posti";
  } else if (carrier?.module_name == "itella" || identifier == "itella") {
    order_type = "itella";
  } else if (
    carrier?.module_name == "mijoramatkahuolto" ||
    identifier == "matkahuolto"
  ) {
    order_type = "matkahuolto";
  } else if (carrier?.module_name == "zipasgo" || identifier == "zipasgo") {
    order_type = "zipasgo";
  } else {
    order_type = "dpd";
  }

  if (carrier_identifier.includes("_pickup")) {
    delivery = `${order_type}_postMachine`;
  } else if (carrier_identifier.includes("_home")) {
    delivery = order_type == "dpd" ? "dpd_b2c" : `${order_type}_home`;
  } else if (!carrier_identifier) {
    if (parcel_terminal_id) {
      delivery = `${order_type}_postMachine`;
    }
  }
  if (!delivery && !["at_the_store"].includes(order_type)) {
    delivery = order_type == "dpd" ? "dpd_b2c" : `${order_type}_home`;
  }
  // console.log("Priskirimo info: ", { order_type, delivery });

  return {
    order_type,
    delivery,
  };
};

export const have_product_reference = (product_reference) =>
  !["{}", false, "", null].includes(product_reference);

export const have_attr_carrying = (orows) => {
  if (!orows?.length) return false;
  return orows.some((item) => {
    // Check nested childs array first (before checking product_reference)
    // This ensures we check child services even if parent has product_reference
    if (item?.childs?.length > 0) {
      if (have_attr_carrying(item.childs)) return true;
    }
    // Skip items with product reference (real products, not services)
    if (have_product_reference(item.product_reference)) return false;
    // Skip unselected items ONLY for products with reference (not for services)
    // Services (like "kuni 80 kg") don't have product_reference and should always be checked
    // Note: We already passed the have_product_reference check above, so this item is a service
    // Don't skip services based on selected status
    // Check if product name contains UKD keywords
    if (
      uznesimoOptions.some(
        (val) => item.product_name?.toLowerCase().indexOf(val) >= 0,
      )
    )
      return true;
    return false;
  });
};

export const show_parcels = (order_type, delivery) => {
  if (order_type === "omniva" && delivery === "omniva_postMachine")
    return "omniva";
  if (order_type === "lp_express" && delivery === "lp_express_postMachine")
    return "lp_express";
  if (order_type === "dpd" && delivery === "dpd_postMachine") return "dpd";
  if (order_type === "venipak" && delivery === "venipak_postMachine")
    return "venipak";
  if (order_type === "posti" && delivery === "posti_postMachine")
    return "posti";
  if (order_type === "itella" && delivery === "itella_postMachine")
    return "itella";
  if (order_type === "matkahuolto" && delivery === "matkahuolto_postMachine")
    return "matkahuolto";
  return "";
};

export const return_parcels_v2 = (
  parcel_terminals,
  order_type,
  delivery,
  country_code,
) => {
  const parcel_mode = show_parcels(order_type, delivery);
  const reOrder_type = order_type == "itella" ? "posti" : order_type;

  if (!parcel_mode) return [];
  if (!parcel_terminals[reOrder_type]) return [];
  if (!parcel_terminals[reOrder_type][country_code]) return [];
  return parcel_terminals[reOrder_type][country_code];
};

export const buildCountriesArray = (coutries) => {
  if (!coutries) return [];
  if (Array.isArray(coutries)) {
    return coutries.map((e) => ({
      value: e.id,
      label: e.en_name,
    }));
  }
  return [];
};

export const setCod = ({ cod, leasing_cod, shipment_type, payment_module }) => {
  if (["at_the_store"].includes(shipment_type)) return false;
  if (cod) return true;
  if (leasing_cod) return true;
  return false;
};

export const setCodFromWaitingPayments = ({ waiting_payments, shipments }) => {
  const price = last_arr(waiting_payments?.filter((e) => e.cod))?.price;
  if (!price) return null;
  if (
    !shipments.some((shipment) => {
      const additionalCheck = shipment.shipment_additional_services.some(
        (d) =>
          d.service_key == "cod_payment_price" && Number(d.service_value) > 0,
      );
      if (additionalCheck) {
        return (
          shipment.shipment_order_rows?.length > 0 &&
          shipment.shipment_order_rows.every((d) => !d.canceled_at)
        );
      }
      return false;
    })
  ) {
    return price;
  }
  return 0;
};

const checkIfUsedLeasing = ({ orderInfo, shipments }) => {
  const price = orderInfo.leasing_cod ? +orderInfo.leasing_advance : "";
  if (!price) return null;
  if (
    !shipments.some((shipment) => {
      const additionalCheck = shipment.shipment_additional_services.some(
        (d) => d.service_key == "leasing_cod" && Number(d.service_value) > 0,
      );
      if (additionalCheck) {
        return (
          shipment.shipment_order_rows?.length > 0 &&
          shipment.shipment_order_rows.every((d) => !d.canceled_at)
        );
      }
      return false;
    })
  ) {
    return price;
  }
  return 0;
};

// dead func
export const setCodAmount = (orderInfo, waiting_payments) => {
  const waiting_with_cod = waiting_payments?.filter((e) => e.cod);
  if (waiting_with_cod?.length > 0) {
    return waiting_with_cod[waiting_with_cod?.length - 1].price;
  }
  return orderInfo.leasing_cod
    ? orderInfo.leasing_advance
    : orderInfo.total_price || 0;
};

export const possibilityToAssignDeliveryAmount = ({ orderInfo, shipments }) => {
  return +orderInfo.total_shipping_tax_incl > 0 &&
    !shipments.some((shipment) => {
      const hasShippingPrice = shipment.shipment_additional_services.some(
        (d) => d.service_key == "shipping_price" && Number(d.service_value) > 0,
      );
      const isAutoShipmentWithCod =
        shipment.shipment_additional_services.some(
          (d) =>
            d.service_key == "created_through" &&
            d.service_value == "auto_shipment",
        ) &&
        shipment.shipment_additional_services.some(
          (d) => d.service_key == "cod" && Number(d.service_value) > 0,
        );

      if (hasShippingPrice || isAutoShipmentWithCod) {
        return (
          shipment.shipment_order_rows?.length > 0 &&
          shipment.shipment_order_rows.every((d) => !d.canceled_at)
        );
      }
      return false;
    })
    ? +orderInfo.total_shipping_tax_incl
    : 0;
};

const possibilityToAssignCartRule = ({
  order_cart_rules,
  shipments,
  order_rows,
}) => {
  if (order_cart_rules?.length === 0 || order_rows?.length === 0) {
    return null;
  }

  const filtered = order_cart_rules.filter((order_cart_rule) => {
    return !shipments.some((shipment) => {
      const additionalCheck = shipment.shipment_additional_services.some(
        (d) => {
          if (d.service_key !== "cart_rules") return false;
          return (
            d.service_value.includes(order_cart_rule.title + "_") ||
            d.service_value.includes(order_cart_rule.identifier + ": ")
          );
        },
      );
      if (additionalCheck) {
        return (
          shipment.shipment_order_rows?.length > 0 &&
          shipment.shipment_order_rows.every((d) => !d.canceled_at)
        );
      }
      return false;
    });
  });

  if (filtered?.length === 0) {
    return null;
  }

  return filtered.map((order_cart_rule) => ({
    price: +order_cart_rule.total,
    identifier: order_cart_rule.title + "_" + order_cart_rule.identifier,
  }));
};

const availableWaitingPayments = (waiting_payments, shipments) => {
  const waiting_payment_price = setCodFromWaitingPayments({
    waiting_payments,
    shipments,
  });
  if (typeof waiting_payment_price === "number") return waiting_payment_price;
  return null;
};

const availableLeasingCod = (orderInfo, shipments) => {
  const leasing_cod = checkIfUsedLeasing({ orderInfo, shipments });
  if (typeof leasing_cod === "number") return leasing_cod;
  return null;
};

export const setCodAmount2 = ({
  waiting_payments,
  order_rows,
  or_quantity_manual = {},
  shipments,
  orderInfo,
  order_cart_rules,
}) => {
  const waiting_payment_price = availableWaitingPayments(
    waiting_payments,
    shipments,
  );
  if (typeof waiting_payment_price == "number")
    return {
      type: "cod_payment_price",
      price: toFixedNumber(waiting_payment_price),
    };

  const leasing_cod = availableLeasingCod(orderInfo, shipments);
  if (typeof leasing_cod == "number")
    return { type: "leasing_cod", price: toFixedNumber(leasing_cod) };

  const total_shipping_tax_incl = possibilityToAssignDeliveryAmount({
    orderInfo,
    shipments,
  });

  const selectedParentRows = order_rows.filter(
    (d) => d.selected && !d.parent_id,
  );
  const selectedParentRowIds = new Set(
    selectedParentRows
      .map((d) => Number(d.id))
      .filter((id) => Number.isFinite(id) && id > 0),
  );
  const selectedParentProductIds = new Set(
    selectedParentRows
      .map((d) => Number(d.id_product))
      .filter((id) => Number.isFinite(id) && id > 0),
  );
  const appliedCartRuleIds = new Set(
    (order_rows || [])
      .map((d) => Number(d.order_cart_rule_id))
      .filter((id) => Number.isFinite(id) && id > 0),
  );
  const cartRulesNotAppliedToSelectedRows = (order_cart_rules || []).filter(
    (rule) => {
      if (appliedCartRuleIds.has(Number(rule.id))) return false;

      // or to order_row.id_product depending on source.
      if (rule.id_product) {
        const productRuleId = Number(rule.id_product);
        return (
          selectedParentRowIds.has(productRuleId) ||
          selectedParentProductIds.has(productRuleId)
        );
      }

      return true;
    },
  );

  const total_order_cart_rules =
    cartRulesNotAppliedToSelectedRows.length > 0
      ? possibilityToAssignCartRule({
          order_cart_rules: cartRulesNotAppliedToSelectedRows,
          shipments,
          order_rows: order_rows.filter(
            (d) => !d.order_cart_rule_id && !d.parent_id,
          ),
        })
      : null;

  const priceCounter = () => {
    const counts = [];
    order_rows
      .filter((d) => d.selected)
      .forEach((d) => {
        const adjustedQuantity =
          (+or_quantity_manual[d.id] || +d.quantity || 0) -
          (+d.shipments_count || 0);

        counts.push({
          unit_price_tax_incl: +d.unit_price_tax_incl,
          quantity: adjustedQuantity > 0 ? adjustedQuantity : 0,
        });

        if (Array.isArray(d.childs) && d.childs?.length > 0) {
          d.childs.forEach((child) => {
            counts.push({
              unit_price_tax_incl: +child.unit_price_tax_incl,
              quantity: +child.quantity || 0,
            });
          });
        }
      });

    return counts.reduce(
      (prev, cur) => +cur.unit_price_tax_incl * cur.quantity + prev,
      0,
    );
  };
  let price = priceCounter();

  const options = {};

  const selectedRowsWithCartRule = order_rows.filter(
    (d) => d.selected && d.order_cart_rule_id && !d.parent_id,
  );
  const allSelectedRowsHaveDiscount =
    selectedRowsWithCartRule.length > 0 &&
    order_rows.filter((d) => d.selected && !d.parent_id).length ===
      selectedRowsWithCartRule.length;

  if (
    total_order_cart_rules &&
    Array.isArray(total_order_cart_rules) &&
    !allSelectedRowsHaveDiscount
  ) {
    const reduce_total_order_cart_rules = total_order_cart_rules.reduce(
      (prev, cur) => prev + cur.price,
      0,
    );
    if (price > reduce_total_order_cart_rules) {
      options.total_order_cart_rules = total_order_cart_rules;
      price = price - reduce_total_order_cart_rules;
    }
  }

  if (total_shipping_tax_incl) {
    options.total_shipping_tax_incl = total_shipping_tax_incl;
    price += total_shipping_tax_incl;
  }

  return {
    type: "basic_cod",
    price: toFixedNumber(price),
    options,
  };
};

export const shipment_type_setter = (order_type, delivery) => {
  // Convert posti to itella
  if (order_type === "posti") {
    order_type = "itella";
  }

  // Convert delivery posti to itella
  if (delivery === "posti") {
    delivery = "itella";
  }

  if (order_type == "at_the_store") {
    if (delivery == "lp_express") {
      return `${order_type}_lp`;
    } else if (delivery == "venipak") {
      return `${order_type}_venipak`;
    }
  }
  return order_type;
};

// export const codPayment_module = (val) =>
//   [
//     "ps_cashondelivery",
//     "codfee",
//     "cashondelivery",
//     "cashondeliveryplus",
//     "Kortele pristatymo metu",
//     "Atsiskaitymas banko kortele pristatymo metu",
//   ].includes(val);

export const shipmentAdditionalServicesAttributesParams = (values) => {
  const {
    order_return,
    cod,
    cod_amount,
    deliveryOnSaturday,
    delivery_same_day,
    sendingDocuments,
    who,
    deliveryTime,
    deliveryTimeHours,
    delivery,
    type,
    swap,
    weight,
    packets,
    lp_express_sizes,
    delivery_after_18,
    carrying,
    shipping_price,
    cod_rules,
    created_through,
    recycle,
    connect,
  } = values;
  // console.log(values);
  const defaults = [
    {
      service_key: "order_return",
      service_value: order_return ? 1 : 0,
    },
    {
      service_key: "cod",
      service_value: cod ? cod_amount : null,
    },
    {
      service_key: "sat",
      service_value: deliveryOnSaturday,
    },
    {
      service_key: "delivery_same_day",
      service_value: delivery_same_day,
    },
    {
      service_key: "docret",
      service_value: sendingDocuments ? who : false,
    },
    {
      service_key: "time",
      service_value: deliveryTime
        ? `${deliveryTimeHours[0]} - ${deliveryTimeHours[1]}`
        : null,
    },
    {
      service_key: "delivery",
      service_value: delivery,
    },
    {
      service_key: "carrying",
      service_value: ruleCarrying({ order_type: type, delivery })
        ? carrying
        : false,
    },
    {
      service_key: "swap",
      service_value: swap,
    },
    {
      service_key: "weight",
      service_value: weight,
    },
    {
      service_key: "pack",
      service_value: packets,
    },
    {
      service_key: "lp_express_sizes",
      service_value: lp_express_sizes,
    },
  ];
  const postiValid = validPostiConnect({
    order_type: type,
    delivery,
  });
  if (postiValid && recycle)
    defaults.push({ service_key: "recycle", service_value: 1 });
  if (postiValid && connect)
    defaults.push({ service_key: "connect", service_value: 1 });

  if (
    delivery_after_18 &&
    type == "lp_express" &&
    delivery == "lp_express_home"
  ) {
    defaults.push({
      service_key: "delivery_after_18",
      service_value: delivery_after_18,
    });
  }
  if (created_through)
    defaults.push({
      service_key: "created_through",
      service_value: created_through,
    });

  if (cod) {
    console.log({ cod_rules, tesr: cod_rules?.options });
    if (["basic_cod"].includes(cod_rules?.type)) {
      if (
        cod_rules?.options?.total_order_cart_rules &&
        Array.isArray(cod_rules?.options?.total_order_cart_rules)
      ) {
        cod_rules.options.total_order_cart_rules.forEach((cart_rule) => {
          defaults.push({
            service_key: "cart_rules",
            service_value: `${cart_rule.identifier}: ${cart_rule.price}`,
          });
        });
      }

      if (cod_rules?.options?.total_shipping_tax_incl) {
        defaults.push({
          service_key: "shipping_price",
          service_value: cod_rules.options.total_shipping_tax_incl,
        });
      }
    }

    if (cod_rules?.price) {
      if (+cod_amount == +cod_rules.price) {
        defaults.push({
          service_key: cod_rules.type,
          service_value:
            cod_rules.price -
            (["basic_cod"].includes(cod_rules?.type)
              ? +shipping_price || 0
              : 0),
        });
      }
    }
  }
  return defaults;
};

export const supplyingCount = (supplyings) => {
  if (!supplyings) return 0;
  if (!Array.isArray(supplyings)) return 0;
  return supplyings.reduce((sum, supplying) => sum + +supplying.amount || 0, 0);
};

export const isOrderRowCod = (id_product, order_shop_id) => {
  // if (!id_product) console.error("no id_product");
  // if (!order_shop_id) console.error("no order_shop_id");
  // BB
  if (id_product == 1385756 && order_shop_id == 1) return true;
  if (id_product == 1385766 && order_shop_id == 2) return true;
  if (id_product == 333029 && order_shop_id == 3) return true;
  // TB
  if (id_product == 1048716 && order_shop_id == 4) return true;
  if (id_product == 1048716 && order_shop_id == 5) return true;
  if (id_product == 1048716 && order_shop_id == 6) return true;
  if (id_product == 1385756 && order_shop_id == 7) return true;

  return false;
};

export const orderRowsFilter = (rows, order_shop_id) =>
  rows
    .filter((order_row) => !isOrderRowCod(order_row.id_product, order_shop_id))
    .filter((order_row) => {
      if (!order_row.parent_id) return true;
      if (
        order_row.parent_id &&
        have_product_reference(order_row.product_reference)
      )
        return true;
      const re_rows = rows
        .filter(
          (order_row) => !isOrderRowCod(order_row.id_product, order_shop_id),
        )
        .filter((d) => d.id !== order_row.id);
      if (re_rows?.length == 0) return false;

      return !re_rows.map((d) => d.id).includes(order_row.parent_id);
    });

export const breakdownOfOrderRows = (rows) =>
  rows.filter((order_row) => {
    if (!order_row.parent_id) return true;
    if (have_product_reference(order_row.product_reference)) return true;

    if (
      order_row.parent_id &&
      have_product_reference(order_row.product_reference)
    )
      return true;

    return !rows.find((d) => d.id == order_row.parent_id);
  });

export const orderRowBuildWithParents = (order_rows) =>
  order_rows
    .filter((order_row) => {
      if (!order_row.parent_id) return true;
      if (have_product_reference(order_row.product_reference)) return true;

      if (
        order_row.parent_id &&
        have_product_reference(order_row.product_reference)
      )
        return true;
      return false;
    })
    .map((order_row) => ({
      ...order_row,
      childs: order_rows.filter(
        ({ parent_id, product_reference }) =>
          parent_id == order_row.id &&
          !have_product_reference(product_reference),
      ),
    }));

export const availableCountries = (country_id, shop_country_id) => {
  // return [51, 115, 122, 208].includes(country_id);
  return country_id == shop_country_id;
};

export const onlyFiOrders = (user_id) => [96, 112].includes(user_id);

// Order shop filter helpers (AMAZON group)
const SHOP_ORDER = [
  "BB LT",
  "BB EE",
  "BB LV",
  "BB FI",
  "TR LT",
  "AMAZON",
  "AM DE",
  "AM ES",
  "AM FR",
  "AM GB",
  "AM IT",
  "AM NL",
  "AM SE",
  "AM PL",
  "AM BE",
  "AM IE",
  "TB LT",
  "TB EE",
];
export const AMAZON_GROUP = "__AMAZON__";

export const getAmazonValues = (shops = []) =>
  shops.filter((s) => s.label?.startsWith("AM ")).map((s) => s.value);

export const sortOrderShops = (shops = []) => {
  const shopMap = new Map(shops.map((s) => [s.label, s]));
  const sorted = SHOP_ORDER.flatMap((label) =>
    label === "AMAZON"
      ? [{ label: "AMAZON", value: AMAZON_GROUP }]
      : shopMap.get(label)
        ? [shopMap.get(label)]
        : [],
  );
  return [...sorted, ...shops.filter((s) => !SHOP_ORDER.includes(s.label))];
};

export const handleAmazonGroup = (newVals, prevVals, allAmazonIds) => {
  const added = newVals.find(
    (v) => v === AMAZON_GROUP && !prevVals.includes(v),
  );
  const removed =
    prevVals.includes(AMAZON_GROUP) &&
    !newVals.includes(AMAZON_GROUP) &&
    allAmazonIds.every((v) => prevVals.includes(v));
  let result = newVals.filter((v) => v !== AMAZON_GROUP);
  if (added) result = [...new Set([...result, ...allAmazonIds])];
  else if (removed) result = result.filter((v) => !allAmazonIds.includes(v));
  return result;
};

export const addAmazonGroupIfAll = (vals, allAmazonIds) =>
  allAmazonIds.length && allAmazonIds.every((v) => vals.includes(v))
    ? [...vals, AMAZON_GROUP]
    : vals;

// Warehouses which receive the order through API (Also, Adrem, Vlantana, ACC) - mirrors Shipment#make_courier_call rules
export const isWarehousePickupAddress = (pickup_address) => {
  const code = (pickup_address?.code || "").toUpperCase();
  if (!code) return false;
  return (
    code === "ALSO/BIGBOX SANDELYS" ||
    code.includes("ADREM") ||
    code.includes("AD REM LEZ") ||
    code.includes("VLANTANA") ||
    code.includes("ACC")
  );
};

// Office pickup address used for new labels
export const findOfficePickupAddress = (pickup_addresses = []) =>
  pickup_addresses.find((pa) =>
    (pa.code || "").toLowerCase().includes("naujas lipdukas")
  ) ||
  pickup_addresses.find((pa) => pa.address === "Veiverių g. 171");

const serviceIsTrue = (value) => value === true || value === "true" || value === "1" || value === 1;

// Builds shipment form values from an existing shipment
export const shipmentToFormValues = (shipment) => {
  const services = (shipment.shipment_additional_services || []).reduce(
    (acc, service) => {
      acc[service.service_key] = service.service_value;
      return acc;
    },
    {}
  );
  const shipment_address = shipment.shipment_address || {};
  const name = shipment_address.name || "";
  const cod_value = services.cod;
  const has_cod = cod_value !== undefined && cod_value !== null && cod_value !== "" && +cod_value > 0;
  const time = services.time ? services.time.split(" - ") : null;
  const docret = services.docret && services.docret !== "false" ? services.docret : null;
  const type = shipment.shipment_type === "posti" ? "itella" : shipment.shipment_type;
  const delivery_raw = services.delivery || type || "dpd";

  return {
    address: {
      firstname: name.split(" ")[0] || "",
      lastname: name.split(" ").slice(1).join(" ") || "",
      postal_code: shipment_address.postal_code || "",
      street: shipment_address.address || "",
      city: shipment_address.city || "",
      phone: shipment_address.phone || "",
      other: shipment_address.email || "",
      comment: shipment_address.comment || "",
      country_id: shipment_address.country_id,
      country: shipment_address.country,
      parcel_terminal_id: shipment_address.parcel_terminal_id,
    },
    general: {
      weight: +services.weight || +shipment.weight || 1,
      pack: +services.pack || +shipment.packets || 1,
      cod: has_cod,
      cod_amount: has_cod ? +cod_value : 0,
      order_return: serviceIsTrue(services.order_return),
      deliveryOnSaturday: serviceIsTrue(services.sat),
      delivery_same_day: serviceIsTrue(services.delivery_same_day),
      sendingDocuments: !!docret,
      who: docret || "",
      deliveryTime: !!time,
      deliveryTimeHours: time || ["", ""],
      carrying: serviceIsTrue(services.carrying),
      swap: serviceIsTrue(services.swap),
      lp_express_sizes: services.lp_express_sizes || undefined,
      delivery_after_18: serviceIsTrue(services.delivery_after_18),
      suppliers: shipment.pickup_address_id,
    },
    type,
    delivery: delivery_raw.includes("posti") ? delivery_raw.replace("posti", "itella") : delivery_raw,
    selectedCarrier: shipment.final_carrier || "sendDirectly",
  };
};
